import React from "react";

import GuideContinent from "./component/GuideContinent";
import GuideCountry from "./component/GuideCountry";
import GuideCity from "./component/GuideCity";
import GuideType from "./component/GuideType";

const GuideCocktayl = (props) => {
  const { slugs } = props;
  if (slugs.length === 1) {
    return <GuideContinent {...props} continentSelected={slugs[0]} />;
  } else if (slugs.length === 2) {
    return (
      <GuideCountry
        {...props}
        continentSelected={slugs[0]}
        countrySelected={slugs[1]}
      />
    );
  } else if (slugs.length === 3) {
    return (
      <GuideCity
        {...props}
        continentSelected={slugs[0]}
        countrySelected={slugs[1]}
        citySelected={slugs[2]}
      />
    );
  } else if (slugs.length === 4) {
    return (
      <GuideType
        {...props}
        continentSelected={slugs[0]}
        countrySelected={slugs[1]}
        citySelected={slugs[2]}
        typeSelected={slugs[3]}
      />
    );
  }
};

export default GuideCocktayl;
